<template>
  <div id="app" v-loading="loading">
    <router-view/>
  </div>
</template>

<script>
import {getInitConfig} from '@/config/config';
export default {
  name: 'App',
  computed: {
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    initConfig () {
      let config = getInitConfig()
      document.title = config.title
      if (config.ico) {
        let link = document.getElementById('ico-link')
        link.href = config.ico
        link.type = ''
        link.type = 'image/x-icon'
      }
    }
  },
  mounted () {
    this.initConfig()
  },
  created () {
    // let str = window.location.hash.split('?')[1]
    // let ticket = str.split('=')[1]
    // if (ticket) {
    //   window.localStorage.setItem('token', ticket)
    // }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666666;
  font-size: 14px;
  /* margin-top: 60px; */
}
*{
  font-family: "Microsoft YaHei"
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
a {
  text-decoration: none;
  color: #333;
}
button {
  border: none;
  outline: none;
  cursor: pointer;
}
select,
input {
  outline: none;
}
a:visited {
  color: #333;
}

.agent-right-title a {
  color: #333;
}

.agent-right-title a:hover {
  color: #0078ff;
}
.right-fixed{
  position:fixed;
  right:0;
  top:194px;
  z-index:9999;
}
img{
  border:none;
}
i{
  font-style:normal;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  font-size: 16px !important;
  font-weight: bold;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item{
  font-size: 16px !important;
}
.el-table__fixed-right{
    height: 100% !important;
}
/* //滚动条的宽度 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: none;
}
/* //滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: rgba(144,147,153,.3);
  border-radius: 5px;
}
/* .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 4px rgb(0 0 0 / 10%);
  background: #c9dff7;
} */
/* #nprogress .bar {
    background: red !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue